import { createSlice } from "@reduxjs/toolkit";

export const hourlySlice = createSlice({
  name: "hourlySpace",
  initialState: {
    hourlyState: {},
  },
  reducers: {
    setHourlyState(state, { type, payload }) {
      switch (type) {
        case "hourlySpace/setHourlyState":
          state.hourlyState = {
            ...state.hourlyState,
            ...payload,
          };
          break;
      }
    },
  },
});
const { setHourlyState } = hourlySlice.actions;
export { setHourlyState };
export const hourlyStateSelector = (state: any) => state.hourlyReducer.hourlyState;
export default hourlySlice.reducer;
